import axios from "axios";
import "katex/dist/katex.min.css";
import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import { Link } from "react-router-dom";
import rehypeKatex from "rehype-katex";
import remarkMath from "remark-math";
import "../../css/Blog.css";

const BlogList = ({ selectedCategory, selectedTags }) => {
  const [groupedPosts, setGroupedPosts] = useState({});

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const url = `${process.env.REACT_APP_BASE_API_URL}/api/blogs/`;
        const params = {};
        if (selectedCategory) params.category = selectedCategory;
        if (selectedTags?.length > 0) params.tags = selectedTags.join(",");

        const response = await axios.get(url, { params });

        const grouped = response.data.reduce((acc, post) => {
          const category = post.category_name;
          if (!acc[category]) acc[category] = [];
          acc[category].push(post);
          return acc;
        }, {});

        const sortedGrouped = Object.keys(grouped)
          .sort()
          .reduce((acc, key) => {
            acc[key] = grouped[key];
            return acc;
          }, {});

        setGroupedPosts(sortedGrouped);
      } catch (error) {
        console.error("Error fetching posts:", error);
      }
    };
    fetchPosts();
  }, [selectedCategory, selectedTags]);

  return (
    <div>
      {Object.entries(groupedPosts).map(([category, categoryPosts]) => (
        <div key={category} className="mb-5">
          <h3 className="blog-category-heading">{category}</h3>
          <div className="blog-list">
            {categoryPosts.map((post) => (
              <div key={post.id} className="blog-list-item">
                {post.featured_image && (
                  <Link
                    to={`/blogs/${post.slug}`}
                    className="blog-list-image-link"
                  >
                    <img
                      src={post.featured_image}
                      alt={post.title}
                      className="blog-list-thumbnail"
                    />
                  </Link>
                )}
                <div className="blog-list-content">
                  <h4 className="blog-list-title">
                    <Link
                      to={`/blogs/${post.slug}`}
                      className="blog-title-link"
                    >
                      {post.title}
                    </Link>
                  </h4>
                  <div className="blog-meta mb-2">
                    {new Date(post.created_at).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })}{" "}
                    · {post.read_time} min read
                  </div>
                  <div className="blog-tags mb-2">
                    {post.tags.map((tag) => (
                      <span key={tag.id} className="me-1 blog-tag-badge">
                        {tag.name}
                      </span>
                    ))}
                  </div>
                  <div className="blog-summary">
                    <ReactMarkdown
                      remarkPlugins={[remarkMath]}
                      rehypePlugins={[rehypeKatex]}
                    >
                      {post.summary}
                    </ReactMarkdown>
                  </div>
                  <Link
                    to={`/blogs/${post.slug}`}
                    className="blog-read-more mt-1"
                  >
                    Read more →
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default BlogList;
